import classNames from 'classnames'
import { Button, Select, SelectButton, SelectButtonCaret, SelectDropdown, Suspense, usePaginate } from 'journey-ui'
import React, { useContext, useState } from 'react'
import { ToppingContext } from '../../contexts/ToppingContext'
import { RequiresActionPulse } from '../Menu/RequiresActionPulse'

interface Props {

}

export const ToppingOptionSelect: React.FC<Props> = () => {
  const { topping, setTopping } = useContext(ToppingContext)

  const onOptionClick = async (toppingOption: ToppingOption) => {
    setTopping((prevTopping) => ({
      ...prevTopping,
      topping_option_name: toppingOption.name,
    }))
  }

  const [open, setOpen] = useState(false)

  const [toppingOptions, setToppingOptions, toppingOptionPaginator] = usePaginate<ToppingOption>({
    url: `/api/topping-option-list/${topping.topping_option_list_hash_id}/topping-option`,
    isAllowed: !!topping.topping_option_list_hash_id,
  })

  if (!topping.topping_option_list_hash_id) {
    return null
  }

  const missingSelection = !topping.topping_option_name

  return (
    <Select onOpen={() => setOpen(true)} onClose={() => setOpen(false)} isOpen={open}>
      <SelectButton className={classNames('w-full rounded-none border-none', { 'overflow-visible': missingSelection })}>
        {missingSelection ? <RequiresActionPulse /> : null}
        <div className="flex space-x-4 justify-between w-full">
          <div className="flex-shrink-0">How would you like it?</div>
          <div className="flex items-center flex-shrink-0 flex-nowrap max-w-[200px]">
            <span>{topping.topping_option_name}</span>
            <SelectButtonCaret />
          </div>
        </div>
      </SelectButton>
      <SelectDropdown>
        <Suspense hook={toppingOptionPaginator}>
          {toppingOptions.map((toppingOption) => (
            <Button key={toppingOption.hash_id} className="rounded-none border-none w-full" onClick={() => onOptionClick(toppingOption)}>
              {toppingOption.name}
            </Button>
          ))}
        </Suspense>
      </SelectDropdown>
    </Select>
  )
}
